"use strict";

exports.__esModule = true;
exports.getWidgetCSSProps = getWidgetCSSProps;
var _polished = require("polished");
/**
 * Get CSS properties from widget props.
 */
function getWidgetCSSProps(_ref) {
  var color = _ref.color,
    backgroundColor = _ref.backgroundColor,
    fontFamily = _ref.fontFamily,
    fontSize = _ref.fontSize,
    fontStyle = _ref.fontStyle,
    fontWeight = _ref.fontWeight,
    textDecoration = _ref.textDecoration,
    textAlign = _ref.textAlignment,
    width = _ref.width,
    height = _ref.height;
  var safeColor = color;
  if (!safeColor && backgroundColor) {
    safeColor = (0, _polished.readableColor)(backgroundColor);
  }
  return {
    color: safeColor,
    backgroundColor: backgroundColor,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontStyle: fontStyle,
    fontWeight: fontWeight,
    textDecoration: textDecoration,
    textAlign: textAlign,
    width: width,
    height: height
  };
}